import React from "react";

export default function TailorSettings() {
  return (
    <>
      <div className="fikseTextHeader">€Admin Settings</div>
      <div className="fikseTextGrey defaultPaddingLeft w-2/5 pb-14">
        €Give people access to your Fikse company profile, sharing link and be happy{" "}
      </div>
      <div className="h-20 border-t border-black"></div>
    </>
  );
}
